import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Box, Avatar, alpha, Stack, Button, Divider } from '@mui/material';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import { TypeAnimation } from 'react-type-animation';

export default function Introduction () {

    const scrollToSection = (sectionId: string) => {
        const sectionElement = document.getElementById(sectionId);
        const offset = 128;
        if (sectionElement) {
          const targetScroll = sectionElement.offsetTop - offset;
          sectionElement.scrollIntoView({ behavior: 'smooth' });
          window.scrollTo({
            top: targetScroll,
            behavior: 'smooth',
          });
        }
      };

    return (
        <Box
          id='introduction'
          sx={(theme) => ({
            width: '100%',
            backgroundImage:
              theme.palette.mode === 'light'
                ? 'linear-gradient(180deg, #CEE5FD, #FFF)'
                : `linear-gradient(#02294F, ${alpha('#090E10', 0.0)})`,
            backgroundSize: '100% 20%',
            backgroundRepeat: 'no-repeat',
          })}
            >
        {/* <Box    
          src={backgroundImage}
          alt="background"
          component="img"
          sx={{
            width:'100%',
            height:'calc(100vh - 450px)',
            position:'absolute',
            top: '40%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: -99,
            objectFit: 'cover',
        }}
        /> */}
        <Container 
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            pt: { xs: 14, sm: 20 },
            pb: { xs: 4, sm: 6 },
        }}
        > 
            <Stack spacing={2} useFlexGap sx={{ width: { xs: '100%', sm: '70%' } }}>
                <Typography
                    component="h3"
                    variant="h2"
                    sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignSelf: 'center',
                    textAlign: 'center',
                    }}
                >
                    I am&nbsp;
                    <Typography
                    component="span"
                    variant="h2"
                    sx={{
                        color: (theme) =>
                        theme.palette.mode === 'light' ? 'primary.main' : 'primary.main',
                    }}
                    >
                    Eric Wu.
                    </Typography>
                </Typography>
                <Avatar
                    alt="icon"
                    variant='rounded'
                    src={require('../images/profilephoto.jpg')}
                    sx={{ width: 180, height: 180, my:2, alignSelf:'center',borderRadius:'50%' }}
                />
                <Typography variant="body1" textAlign="center" color="text.secondary" sx={{padding:2, borderRadius:10, boxShadow: '1px 1px #005ca8, -1em 0 1em #005ca8'}}>
                  <TypeAnimation
                  sequence={[
                    `Empowering Growth and Learning in Tech, background in Web Dev, E-commerce and Sales & Marketing. \n I aim to further expand my diverse skills and knowledge`,
                    1000,
                  ]}
                  wrapper='span'
                  speed={60}
                  cursor={false}
                />
              </Typography>
            </Stack>
            <Divider variant='middle' style={{width:'60%', margin:'auto',marginTop: 100}}>
              <Button onClick={()=> scrollToSection('projects')} style={{alignSelf:'center', background:'none'}}>
                  <ArrowCircleDownIcon sx={{color: 'grey', fontSize:40, '&&:hover':{background:'none', color:'primary.main'} }}/>
              </Button>
            </Divider>
        </Container>
        </Box>
    );
}